export default {"src":"/_next/static/media/eg.3295759d.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};